import PrintApi from '@/api/piglet/pigletPrintApi';

export default {
  namespaced: true,
  states: {

  },
  mutations: {

  },
  actions: {
    async printPreview({dispatch}, {deliveries, context}) {
      try {
        const response = await PrintApi.printPreview(deliveries, context);
        return Promise.resolve(response.data);
      }
      catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async print({dispatch}, {deliveries, context}) {
      try {
        const response = await PrintApi.print(deliveries, context);
        return Promise.resolve(response.data);
      }
      catch (error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
